import { FC } from "react";
import { Button, Divider, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { InfoIcon, NextArrowIcon } from "src/assets/Icons";
import BannerCard from "src/components/BannerCard/BannerCard";
import { POLICIES, type MiniRule } from "src/Modules/Flights/constants/JourneyListing";
import { formulateRule, mapMiniRules } from "../../../utils";

const MiniRuleSegmentCard: FC<{ miniRule: MiniRule[] }> = ({ miniRule }) => {
  const mappedMiniRules = mapMiniRules(miniRule)?.[0];
  const keyList = mappedMiniRules.key.split("-");
  return (
    <div className="font-inter flex w-full flex-col gap-2 md:gap-5">
      <div className="inter-semibold flex gap-1 p-1 text-xs md:text-sm">
        {keyList.map((key, index) => {
          return (
            <div className="flex items-center gap-1">
              <Tag
                key={key}
                color="var(--color-font-informative)"
                className="font-semibold! px-2! "
              >
                {key}
              </Tag>
              {index !== keyList.length - 1 && (
                <div>
                  <NextArrowIcon className="text-icon-minimal w-2 h-2 md:w-4 md:h-4"/>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="grid grid-cols-1 gap-3 px-3 md:grid-cols-2">
        {mappedMiniRules.policies.map((policy) => {
          const policyObject = POLICIES.find((policyObject) => policyObject.type === policy.type);
          return (
            <BannerCard
              key={policy.type}
              className="px-3 py-4 rounded-e-sm"
              rootClassName="ps-1! rounded-e-lg "
              rootStyles={{ background: policyObject?.bannerColor }}
              style={{ background: policyObject?.bgColor }}
            >
              <div className="grid w-full grid-cols-[min-content_1fr] grid-rows-[min-content_1fr] gap-2">
                <div style={{ background: policyObject?.iconBgColor }} className="rounded-md p-3">
                  {policyObject?.icon}
                </div>
                <div style={{ color: policyObject?.bannerColor }} className="flex items-center text-sm font-semibold md:text-lg">
                  {policyObject?.label}
                </div>
                <div className="font-inter col-start-2 row-start-2 text-font-default">
                  <ul style={{ listStyleType: "disc", paddingLeft: "10px" }}>
                    {policy.rules.map((rule) => {
                      return <li key={`${rule.from}-${rule.to}`}>{formulateRule(rule)}</li>;
                    })}
                  </ul>
                </div>
              </div>
            </BannerCard>
          );
        })}
      </div>
    </div>
  );
};

const MiniFareRulesContent: FC<{ miniRules: MiniRule[][]; onClose: () => void }> = ({ miniRules, onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-col gap-2">
        {miniRules.map((segmentRules, index) => {
          return <MiniRuleSegmentCard miniRule={segmentRules} key={`segmentRules-${index}`} />;
        })}
      </div>
      <Divider className="m-1!"/>
      <div className="flex md:flex-row flex-col md:items-center justify-between gap-3">
        <div className="md:text-14 flex items-center gap-1 text-xs">
          <InfoIcon />
          {t("Flights.listing.fareRulesDisclaimer")}
        </div>
      </div>
    </div>
  );
};

export default MiniFareRulesContent;
